import { createUseStyles } from 'react-jss'

export default createUseStyles({
  container: {
    display: 'flex',
    marginBottom: '30px',
  },
  element: {
    width: '30%',
    '@media(max-width: 900px)': {
      width: '100%',
    }
  }
})
